<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        >
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="saleman">
        <Button size="small" @click="fenpai(row, index)">立即分派</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model title="分派业务员" width="400" ref="formModel">
      <FormItem slot="form" slot-scope="{ row }" label="名称" prop="name">
        <Input
          v-model="row"
          maxlength="10"
          show-word-limit
          placeholder="请输入名称"
        ></Input>
      </FormItem>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        {
          title: "客户名称",
          key: "customer",
          sort: 0,
        },

        {
          title: "联系人",
          key: "contact",
          sort: 0,
        },
        {
          title: "电话",
          key: "tel",
          required: true,
          sort: 0,
        },
        {
          title: "备注",
          key: "remark",
          sort: 0,
        },
      ],
      tableData: [],
      item: {
        id: 0,
        saleman: "",
        salemanId: "",
      },

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          type: "lyyymmdd",
          times: "4,2,0",
        },
      ],
      total: 0,
      forms: [
        {
          title: "分派业务员",
          slot: "saleman",
          key4: "salemanId",
          key1: "saleman",
          multiple: true,
          type: "selectUser",
          required: true,
          span: 24,
        },
      ],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-smm/orders/listAssign",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item = a;
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-smm/orders/assign",
        data: this.item,
      }).then((res) => {
        if (res) {
          this.$refs.formModel.close();
          this.getList();
        }
      });
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.dm + "/carType/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    fenpai(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    //carTypeCategory
    getDictionary() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: "/dictionary/item",
        data: {
          keyword: "carTypeCategory",
        },
      }).then((res) => {
        console.log(res);
        this.$Spin.hide(); //关闭加载
        var a = JSON.parse(res.data.data.value);
        var arr = [];
        for (const i in a) {
          arr.push(a[i].name);
        }
        for (let i = 0; i < this.forms.length; i++) {
          if (this.forms[i].key == "category") {
            this.forms[i].selectItems = arr;
          }
        }
      });
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 240,
    };
    this.columns = this.utils.cols(this.forms, this.columns);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 300);
    this.getDictionary();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/xiaoshou/daifenpai.vue